import { CollectiblesSection } from "../components/BrandSections";
import CTABand from "../components/CTABand";

export default function CollectiblesPage() {
  return (
    <main className="pt-[72px]" data-testid="collectibles-page">
      <CollectiblesSection />
      <CTABand title="Maximize your grails." sub="Clean, grade and consign with the calibre we handle every day — without the international hassle." />
    </main>
  );
}
